import { Field, IMessageProps, NumericInput, TextOutput } from 'Components/Core';
import { Grid } from 'Components/Layout';
import { WorksheetGridFieldSection } from 'Components/Worksheets/Core';

interface ILayerBoundariesProps {
  results: any[];
  onRemoveRow: (index: number) => void;
  onCreateRow: () => void;
  messages?: IMessageProps[];
}

let LayerBoundariesGrid: React.FC<ILayerBoundariesProps> = ({ results, onRemoveRow, onCreateRow, messages }) => {
  return (
    <WorksheetGridFieldSection name="LayerBoundaries" heading="Layer Boundaries" messages={messages}>
      <Grid
        disabled={false}
        colHeaders={['Total Blows', 'Depth (mm)', 'Layer Thickness (mm)', 'mm/Blow', 'CBR (%)']}
        data={createGridData(results)}
        onRemoveRow={onRemoveRow}
        onCreateRow={onCreateRow}
        rows={Array(2)
          .fill(undefined)
          .map((_, r) => ({ preventRemoveRow: r === 0 }))}
        tabDirection={'vertical'}
      />
    </WorksheetGridFieldSection>
  );
};

const createGridData = (results: any[]) => {
  var res = results.map((x: any, i: number) => [
    <Field input={i === 0 ? <TextOutput /> : <NumericInput />} name={`LayerBoundaries[${i}].TotalBlows`} />,
    <Field input={<TextOutput />} name={`LayerBoundaries[${i}].Depth`} />,
    <Field
      input={<TextOutput />}
      name={`LayerBoundaries[${i}].LayerThickness`}
      blankReplacement={i === 0 ? 'N/A' : undefined}
    />,
    <Field
      input={<TextOutput />}
      name={`LayerBoundaries[${i}].PenetrationRate`}
      blankReplacement={i === 0 ? 'N/A' : undefined}
    />,
    <Field input={<TextOutput />} name={`LayerBoundaries[${i}].CBR`} blankReplacement={i === 0 ? 'N/A' : undefined} />,
  ]);

  return res;
};

export { LayerBoundariesGrid };
